import React from "react";

const RectangleIcon = () => {
  return (
    <svg
      width="66"
      height="67"
      viewBox="0 0 66 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.71289"
        y="3.11328"
        width="60.7871"
        height="60.7871"
        stroke="#264D51"
        strokeWidth="5"
      />
    </svg>
  );
};

export default RectangleIcon;
